export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const downloadFileFromUrl = async (url, name) => {
  const link = document.createElement('a');

  link.setAttribute('href', url);
  link.setAttribute('download', name);

  link.click();
};

export const base64ToBlob = (base64) => {
  const byteString = atob(base64.split(',')[1]);
  const mimeType = base64.split(',')[0].split(':')[1].split(';')[0];

  const byteNumbers = new Array(byteString.length);
  for (let i = 0; i < byteString.length; i += 1) {
    byteNumbers[i] = byteString.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

export const base64ToLink = async (base64, filename) => {
  const link = document.createElement('a');

  const fileBlob = base64ToBlob(base64);
  const url = URL.createObjectURL(fileBlob);

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const removeFileExtension = (filename) => {
  return filename.replace(/\.[^/.]+$/, '');
};
